export default "__VITE_ASSET__DK2$uSiA__"